// extracted by mini-css-extract-plugin
export default {"friendcard":"FriendCard_friendcard__CiLKR","photo":"FriendCard_photo__pi8Vm","btn":"FriendCard_btn__pxuux","new":"FriendCard_new__aqaRD"};